var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperF(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 63,
    viewBox: "0 0 39 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.46094 1.50999H1.71094V3.25999H0.210938V0L3.46094 0.00999451V1.50999ZM0.210938 10.86H1.71094V15.61H0.210938V10.86ZM1.71094 23.21H0.210938V27.96H1.71094V23.21ZM0.210938 47.91H1.71094V52.66H0.210938V47.91ZM0.210938 60.27H1.71094V62.77H0.210938V60.27ZM1.71094 35.56H0.210938V40.31H1.71094V35.56ZM11.2358 0.0459633L11.2324 1.54596L16.0924 1.55699L16.0958 0.0569903L11.2358 0.0459633ZM23.874 1.57556L23.8772 0.0755648L28.7372 0.0857436L28.734 1.58574L23.874 1.57556ZM36.5009 0.0674466L36.498 1.56744L38.998 1.57224L39.0009 0.0722463L36.5009 0.0674466ZM26.7412 30.59H30.7412V32.09H26.7412V30.59ZM10.7412 30.59H6.74121V32.09H10.7412V30.59ZM16.7412 30.59H20.7412V32.09H16.7412V30.59Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperF);
export default __webpack_public_path__ + "static/media/UPPER_F.47e7aed2363504effa6d77353cb38837.svg";
export { ForwardRef as ReactComponent };